import { findingViewType_Parent } from '@app/advisor-ui-shared';
import { ModuleFE_Advisor_FindingView } from '@app/advisor-frontend';
import { sortArray } from '@nu-art/ts-common';
export const generateFindingViewButton = (findingView) => {
    return {
        key: findingView._id,
        label: findingView.label,
        // disabled: !ModuleFE_Advisor_FindingView.isVisible.view(findingView),
        disabled: false, //Locking all FV to false ATM
    };
};
export const generateTopLevelFindingViewButtons = () => {
    const topLevelViews = ModuleFE_Advisor_FindingView.getTopLevelViews();
    return topLevelViews.map(generateFindingViewButton);
};
export const generateChildrenLevelFindingViewButtons = (parentViewId) => {
    const parentView = ModuleFE_Advisor_FindingView.cache.unique(parentViewId);
    if (!parentView || parentView.type !== findingViewType_Parent)
        return [];
    const childrenViews = ModuleFE_Advisor_FindingView.cache.filter(view => parentView.childrenIds.includes(view._id));
    sortArray(childrenViews, view => parentView.childrenIds.indexOf(view._id));
    return childrenViews.map(generateFindingViewButton);
};
//# sourceMappingURL=consts.js.map